import React from 'react';
import PropTypes from 'prop-types';

const ICON_SIZE = 16;

function StarEmptyIconSmall({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={ICON_SIZE}
      height={ICON_SIZE}
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        fillOpacity=".1"
        d="M8.05 11.196L4.448 13.09l.688-4.012L2.22 6.236l4.029-.585L8.05 2l1.801 3.65 4.029.586-2.915 2.842.688 4.012z"
      />
    </svg>
  );
}

StarEmptyIconSmall.propTypes = {
  className: PropTypes.string,
};

StarEmptyIconSmall.ICON_SIZE = ICON_SIZE;

export default StarEmptyIconSmall;
